// extracted by mini-css-extract-plugin
export default {"tabsContainer":"_1MMZnGth","tab":"_2CYvzwSd","tabActive":"_2rkRB4ab"};